import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagetextalternative/imagetextalternativeediting
 */
import ImageTextAlternativeCommand from "./imagetextalternativecommand";
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * The image text alternative editing plugin.
 *
 * Registers the `'imageTextAlternative'` command.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageTextAlternativeEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(ImageTextAlternativeEditing, _Plugin);

  function ImageTextAlternativeEditing() {
    _classCallCheck(this, ImageTextAlternativeEditing);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageTextAlternativeEditing).apply(this, arguments));
  }

  _createClass(ImageTextAlternativeEditing, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      this.editor.commands.add('imageTextAlternative', new ImageTextAlternativeCommand(this.editor));
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'ImageTextAlternativeEditing';
    }
  }]);

  return ImageTextAlternativeEditing;
}(Plugin);

export { ImageTextAlternativeEditing as default };